import React from 'react'

const Loading = () => {
  return (
    <div className='parent'>
        <div className="progress">
            <div className="color"></div>
        </div>
    </div>
  )
}

export default Loading